import { useState } from "react";
import { Minus, Plus, ShoppingBag, Leaf, FlaskConical, Rabbit, Flame } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../config/site";

export const BuyBox = ({ product, ctaLabel = "Aggiungi al carrello" }) => {
  const { add } = useCart();
  const [qty, setQty] = useState(1);

  return (
    <div data-testid={`buy-box-${product.slug}`} className="space-y-4">
      <div className="flex items-baseline gap-3">
        <span className="font-serif text-4xl text-plum" data-testid={`buybox-price-${product.slug}`}>
          {formatPrice(product.price)}
        </span>
        {product.compare_at && (
          <span className="text-lg text-plum/40 line-through">{formatPrice(product.compare_at)}</span>
        )}
      </div>
      {product.duration && <p className="text-sm text-plum/60">{product.format} • {product.duration}</p>}
      {!product.duration && product.format && <p className="text-sm text-plum/60">{product.format}</p>}
      {typeof product.stock_left === "number" && (
        <p
          data-testid={`buybox-stock-${product.slug}`}
          className="inline-flex items-center gap-1.5 bg-amber-300 text-plum text-[11px] font-bold uppercase tracking-[0.14em] px-3.5 py-2 rounded-full shadow-[0_8px_20px_-8px_rgba(217,119,6,0.6)]"
        >
          <Flame className="w-3.5 h-3.5" />
          {product.stock_left > 0 ? `Ne restano solo ${product.stock_left}` : "Esaurito al momento"}
        </p>
      )}
      {["trattamento", "scrub"].includes(product.category) && (
        <div className="flex flex-wrap gap-2" data-testid="trust-badges">
          <span className="inline-flex items-center gap-1.5 bg-lilac-soft text-plum/70 text-[11px] font-semibold px-3 py-1.5 rounded-full">
            <Leaf className="w-3.5 h-3.5 text-matcha" /> Senza siliconi
          </span>
          <span className="inline-flex items-center gap-1.5 bg-lilac-soft text-plum/70 text-[11px] font-semibold px-3 py-1.5 rounded-full">
            <FlaskConical className="w-3.5 h-3.5 text-matcha" /> Senza parabeni
          </span>
          <span className="inline-flex items-center gap-1.5 bg-lilac-soft text-plum/70 text-[11px] font-semibold px-3 py-1.5 rounded-full">
            <Rabbit className="w-3.5 h-3.5 text-matcha" /> Cruelty free
          </span>
        </div>
      )}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-3 bg-mist rounded-full px-4 py-3">
          <button
            data-testid="buybox-qty-minus"
            onClick={() => setQty(Math.max(1, qty - 1))}
            className="text-plum hover:text-lilac-dark transition-colors"
            aria-label="Riduci quantità"
          >
            <Minus className="w-4 h-4" />
          </button>
          <span className="font-semibold text-plum w-6 text-center" data-testid="buybox-qty">{qty}</span>
          <button
            data-testid="buybox-qty-plus"
            onClick={() => setQty(Math.min(20, qty + 1))}
            className="text-plum hover:text-lilac-dark transition-colors"
            aria-label="Aumenta quantità"
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
        <button
          data-testid="buybox-add-btn"
          onClick={() => add(product, qty)}
          className="flex-1 flex items-center justify-center gap-2 py-4 rounded-full bg-lilac text-white font-bold text-sm uppercase tracking-[0.12em] hover:bg-lilac-dark active:scale-[0.98] transition-all duration-300"
        >
          <ShoppingBag className="w-4 h-4" />
          {ctaLabel}
        </button>
      </div>
    </div>
  );
};
